module.exports = __webpack_public_path__ + "static/media/ios-quote.ad581947.svg";